import { useState } from "react";
import PasswordInput from "./PasswordInput";
import { useMount, useUpdateEffect } from "react-use";

const FindOutPassword = ({ confirmResult, onUpdate }) => {
  const [password, setPassword] = useState({
    new: "",
    cck: "",
    error: "",
    confirm: false,
  });
  const [error, setError] = useState(null);

  const handlePasswordChange = (e, bError) => {
    setError(null);
    const [target] = e.target.id.split("-");
    if (
      password.new &&
      password.cck &&
      ((target === "new" && password.cck !== e.target.value) ||
        (target === "cck" && password.new !== e.target.value))
    ) {
      setPassword({
        ...password,
        [target]: e.target.value,
        error: "입력한 비밀번호가 일치하지 않습니다.",
      });
    } else {
      setPassword({
        ...password,
        [target]: e.target.value,
        confirm:
          !!password.new &&
          ((target === "new" && password.cck === e.target.value) ||
            (target === "cck" && password.new === e.target.value)),
        error: bError,
      });
    }
  };

  const handleClick = () => {
    onUpdate(password.new);
  };

  useUpdateEffect(() => {
    if (!confirmResult.result) {
      setError(confirmResult.m);
      setPassword({ ...password, confirm: false });
    }
  }, [confirmResult]);

  useMount(() => {
    setPassword({
      new: "",
      cck: "",
      error: "",
      confirm: false,
    });
    setError(null);
  });

  return (
    <div className="flex flex-col">
      <div className="inline-flex items-center gap-2 text-sm">
        <PasswordInput
          {...{
            id: "new-password",
            placeholder: "새 비밀번호",
            className: "text-sm h-10",
            onChange: handlePasswordChange,
            value: password.new,
          }}
        />
      </div>
      <div className="inline-flex items-center gap-2 text-sm">
        <PasswordInput
          {...{
            id: "cck-password",
            placeholder: "새 비밀번호 확인",
            className: "text-sm h-10",
            onChange: handlePasswordChange,
            value: password.cck,
          }}
        />
      </div>
      {!password.confirm && (
        <span className="text-sm text-left text-red-500 mb-2">
          {password.error}
        </span>
      )}
      {!!error && (
        <span className="text-sm text-left text-red-500 mb-2">{error}</span>
      )}
      <button
        className="btn btn-primary"
        disabled={!password.confirm}
        onClick={handleClick}
      >
        {password.confirm}
        확인
      </button>
    </div>
  );
};

export default FindOutPassword;
